<template>
  <!-- Main -->
  <div id="main">
    <!-- 金流 -->
    <div id="mainPayment">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">QR Pay商家</span>
              <a class="setting main"><FontAwesomeIcon icon="cog"/></a>
              <!-- <n-button simple type="primary" style="margin-top: 15px"
                v-if="!isTappayConfigured" @click="showConfigPaymentServiceConfig('tappay')">
                <i class="el-icon-plus"></i>
                新增TapPay服務
              </n-button> -->
              <el-button type="primary" class="btn-add-ps"
                v-if="!isTappayConfigured" @click="showConfigPaymentServiceConfig('tappay')">
                <i class="el-icon-plus"></i>
                新增TapPay服務
              </el-button>
              <el-button type="primary" class="btn-add-ps"
                v-if="!paymentConfigs.linepay.linepay.data" @click="showConfigPaymentServiceConfig('linepay', 'linepay')">
                <i class="el-icon-plus"></i>
                新增LINE Pay
              </el-button>
              <el-button type="primary" class="btn-add-ps"
                v-if="!paymentConfigs.easywallet.easywallet.data" @click="showConfigPaymentServiceConfig('easywallet', 'easywallet')">
                <i class="el-icon-plus"></i>
                新增悠遊付
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item" style="justify-content: space-between;">
              <div class="item" style="width: 100%;">
                <span class="content" style="width: 120px">TapPay</span>
                <div class="payment" :class="{ 'gray': !paymentConfigs.tappay.apple.enabled }">
                  <label class="switch">
                    <input type="checkbox" v-model="paymentConfigs.tappay.apple.enabled"
                      @change="onToggled('tappay.apple')($event)"/>
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Apple.png')" />
                    <span>Apple Pay</span>
                  </div>
                </div>
                <div class="payment" :class="{ 'gray': !paymentConfigs.tappay.google.enabled }">
                  <label class="switch">
                    <input type="checkbox" v-model="paymentConfigs.tappay.google.enabled"
                      @change="onToggled('tappay.google')($event)"/>
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Google.png')" />
                    <span>Google Pay</span>
                  </div>
                </div>
                <div class="payment" :class="{ 'gray': !paymentConfigs.tappay.jko.enabled }">
                  <label class="switch">
                    <input type="checkbox" v-model="paymentConfigs.tappay.jko.enabled"
                      @change="onToggled('tappay.jko')($event)"/>
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/JKO.png')" />
                    <span>街口支付</span>
                  </div>
                </div>
                <div class="payment" :class="{ 'gray': !paymentConfigs.tappay.direct.enabled }">
                  <label class="switch">
                    <input type="checkbox" v-model="paymentConfigs.tappay.direct.enabled"
                      @change="onToggled('tappay.direct')($event)" />
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Credit.png')" />
                    <span>信用卡</span>
                  </div>
                </div>
              </div>
              <a class="setting" @click="showConfigPaymentServiceConfig('tappay')">
                <FontAwesomeIcon icon="cog" v-if="isTappayConfigured"/>
                <FontAwesomeIcon class="setting main" icon="plus" v-else/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item" style="justify-content: space-between;">
              <div class="item" style="width: 100%;">
                <span class="content" style="width: 84px; margin-right: 5px;"
                  >Olink</span
                >
                <div class="payment">
                  <label class="switch">
                    <input type="checkbox" checked />
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Line.png')" />
                    <span>LINE Pay</span>
                  </div>
                </div>
                <div class="payment gray">
                  <label class="switch">
                    <input type="checkbox" />
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Credit.png')" />
                    <span>信用卡</span>
                  </div>
                </div>
              </div>
              <a class="setting"><FontAwesomeIcon icon="cog"/></a>
            </div>
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item" style="justify-content: space-between;">
              <div class="item" style="width: 100%;">
                <span class="content" style="width: 84px; margin-right: 5px;"
                  >台灣Pay</span
                >
                <div class="payment">
                  <label class="switch">
                    <input type="checkbox" checked />
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Bank.png')" />
                    <span>金融卡</span>
                  </div>
                </div>
                <div class="payment">
                  <label class="switch">
                    <input type="checkbox" checked />
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Credit.png')" />
                    <span>信用卡 & 金融卡</span>
                  </div>
                </div>
              </div>
              <a class="setting"><FontAwesomeIcon icon="cog"/></a>
            </div>
          </div>
        </div>
      </div> -->
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item" style="justify-content: space-between;">
              <div class="item" style="width: 100%;">
                <span class="content" style="width: 120px">第三方行動支付</span>
                <div class="payment" :class="{ 'gray': !paymentConfigs.linepay.linepay.enabled }">
                  <label class="switch">
                    <input type="checkbox" v-model="paymentConfigs.linepay.linepay.enabled"
                      @change="onToggled('linepay.linepay')($event)"/>
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Line.png')" />
                    <span>LINE Pay</span>
                  </div>
                  <a class="setting" @click="showConfigPaymentServiceConfig('linepay', 'linepay')">
                    <FontAwesomeIcon icon="cog" v-if="paymentConfigs.linepay.linepay.data"/>
                    <FontAwesomeIcon icon="plus" v-else/>
                  </a>
                </div>
                <!-- <div class="payment">
                  <label class="switch">
                    <input type="checkbox" checked />
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/JKO.png')" />
                    <span>街口支付</span>
                  </div>
                </div> -->
                <div class="payment" :class="{ 'gray': !paymentConfigs.easywallet.easywallet.enabled }">
                  <label class="switch">
                    <input type="checkbox" v-model="paymentConfigs.easywallet.easywallet.enabled"
                      @change="onToggled('easywallet.easywallet')($event)"/>
                    <span class="slider round"></span>
                  </label>
                  <div class="logo">
                    <img :src="require('@/assets/img/gaa-other/Easy.png')" />
                    <span>悠遊付</span>
                  </div>
                  <a class="setting" @click="showConfigPaymentServiceConfig('easywallet', 'easywallet')">
                    <FontAwesomeIcon icon="cog" v-if="paymentConfigs.easywallet.easywallet.data"/>
                    <FontAwesomeIcon icon="plus" v-else/>
                  </a>
                </div>
              </div>
              <!-- <a class="setting"><FontAwesomeIcon icon="cog"/></a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">QR code 出單設定</span>
              <hover-text text="新增">
                <a class="add" @click="showAddQrsDialog()"><FontAwesomeIcon icon="plus"/></a>
              </hover-text>
            </div>
            <table>
              <tr>
                <th><span class="content">名稱</span></th>
                <th><span class="content">序號</span></th>
                <th><span class="content">伺服器</span></th>
                <th><span class="content">出單模板</span></th>
                <th></th>
              </tr>
              <tr
                v-for="(printer, index) in qrsList"
                :key="'printer' + index">

                <td align="center">
                  <span class="content">{{ printer.name }}</span>
                </td>
                <td align="center">
                  <span class="content">{{ printer.sn }}</span>
                  
                </td>
                <td align="center">
                  <span class="content">{{ printer.server }}</span>

                </td>
                <td align="center">
                  <span class="content">{{ printer.order_template_id }}</span>
                </td>
                <td align="center">
                  <div class="action">
                    <hover-text text="編輯"><a @click="showEditQrsDialog(printer)"><FontAwesomeIcon icon="pen"/></a></hover-text>
                    <hover-text text="刪除"><a @click="deleteQrs(printer)"><FontAwesomeIcon icon="trash"/></a></hover-text>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>

    <!-- Dialog - Create a QRPay merchant -->
    <el-dialog :title="`設置商家｜${shopName} (${shopId})`" :visible.sync="dialog.createMerchant.show">
      <el-form label-position="right" label-width="100px">
        <el-form-item label="商家名稱">
          <el-input v-model="dialog.createMerchant.model.name"></el-input>
        </el-form-item>
        <el-form-item label="聯絡電子信箱">
          <el-input v-model="dialog.createMerchant.model.email"></el-input>
        </el-form-item>
        <el-form-item label="聯絡電話">
          <el-input v-model="dialog.createMerchant.model.phone"></el-input>
        </el-form-item>
        <el-form-item label="聯絡地址">
          <el-input v-model="dialog.createMerchant.model.address"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.createMerchant.show = false">取消</el-button>
        <el-button type="primary" @click="createMerchant">確定新增</el-button>
      </span>
    </el-dialog>
    <!-- Dialog - Create a QRPay qrs -->
    <el-dialog :title="dialog.qrs.title" :visible.sync="dialog.qrs.show">

      <el-form label-position="right" label-width="120px" ref="qrsForm" :model="dialog.qrs.model" :rules="qrsRule">
        <el-form-item label="自訂名稱" prop="name">
          <el-input v-model="dialog.qrs.model.name"></el-input>
        </el-form-item>
        <el-form-item label="出單機序號" prop="sn">
          <el-input v-model="dialog.qrs.model.sn" :disabled="dialog.qrs.mode == 'update'"></el-input>
        </el-form-item>
        <el-form-item label="選擇伺服器" prop="server">
          <!-- <el-input v-model="dialog.qrs.model.server" :disabled="dialog.qrs.mode == 'update'"></el-input> -->
            <el-select name="type" placeholder="請選擇" v-model="dialog.qrs.model.server" :disabled="dialog.qrs.mode == 'update'">
              <el-option 
                v-for="(serverOption, index) in serverOptions"
                :key="'serverOption' + index"
                :label="serverOption.label"
                :value="serverOption.value"
                ></el-option
              >
          </el-select>
        </el-form-item>
        <el-form-item label="出單模板" prop="templateId">
          <el-input v-model="dialog.qrs.model.templateId" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="支援訂單通路">
          <!-- <el-input v-model="dialog.qrs.model.platform" disabled></el-input> -->
          <el-select  placeholder="請選擇" v-model="dialog.qrs.model.platform" disabled>
              <el-option 
                v-for="(option, index) in platformOptions"
                :key="'option' + index"
                :label="option.label"
                :value="option.value"
                ></el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideEditQrsDialog">取消</el-button>
        <el-button type="primary" @click="addQrs" v-if="dialog.qrs.mode == 'create'">確定新增</el-button>
        <el-button type="primary" @click="editQrs" v-if="dialog.qrs.mode == 'update'">確定更新</el-button>
      </span>
    </el-dialog>
    <!-- Dialog - Create a QRPay payment service -->
    <el-dialog :title="dialog.configPaymentService.title"
      :visible.sync="dialog.configPaymentService.show">

      <el-form label-position="right" label-width="120px">
        <el-form-item label="自訂名稱">
          <el-input v-model="dialog.configPaymentService.model.name"></el-input>
        </el-form-item>

        <template v-if="dialog.configPaymentService.service == 'linepay'">
          <el-form-item label="Channel ID">
            <el-input v-model="dialog.configPaymentService.model.channelId"></el-input>
          </el-form-item>
          <el-form-item label="Channel Secret">
            <el-input v-model="dialog.configPaymentService.model.channelSecret"></el-input>
          </el-form-item>
        </template>
        <template v-else-if="dialog.configPaymentService.service == 'easywallet'">
          <el-form-item label="Seller Member UID">
            <el-input v-model="dialog.configPaymentService.model.sellerMemberUid"></el-input>
          </el-form-item>
          <el-form-item label="Security Code">
            <el-input v-model="dialog.configPaymentService.model.securityCode"></el-input>
          </el-form-item>
          <el-form-item label="Contract No.">
            <el-input v-model="dialog.configPaymentService.model.contractNo"></el-input>
          </el-form-item>
          <el-form-item label="特店後台管理員帳號">
            <el-input v-model="dialog.configPaymentService.model.executorId"></el-input>
          </el-form-item>
        </template>
        <template v-else-if="dialog.configPaymentService.service == 'tappay'">
          <el-form-item label="TapPay商家ID">
            <el-input v-model="dialog.configPaymentService.model.tappayMerchantId"></el-input>
          </el-form-item>
          <el-form-item label="聯絡人">
            <el-input v-model="dialog.configPaymentService.model.contactName"></el-input>
          </el-form-item>
          <el-form-item label="聯絡電話">
            <el-input v-model="dialog.configPaymentService.model.contactPhone"></el-input>
          </el-form-item>
          <el-form-item label="聯絡地址">
            <el-input v-model="dialog.configPaymentService.model.contactAddress"></el-input>
          </el-form-item>
          <el-form-item label="支援支付選項">
            <el-radio-group v-model="dialog.configPaymentService.model.types">
              <el-radio label="direct">僅一般信用卡</el-radio>
              <el-radio label="apple,google,direct">信用卡支付（Apple Pay、Google Pay、一般信用卡）</el-radio>
              <el-radio label="jko">街口支付</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="3DS驗證">
            <el-checkbox v-model="dialog.configPaymentService.model.useTds">啟用？</el-checkbox>
          </el-form-item>
        </template>

      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.configPaymentService.show = false">取消</el-button>
        <el-button type="primary" @click="createPaymentService" v-if="dialog.configPaymentService.mode == 'create'">確定新增</el-button>
        <el-button type="primary" @click="updatePaymentService" v-if="dialog.configPaymentService.mode == 'update'">確定更新</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import HoverText from "src/components/HoverText.vue";
import axios from 'axios';

export default {
  components: {
    FontAwesomeIcon,
    HoverText
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    },
    shopId: {
      type: String,
      default: ''
    },
    shopName: {
      type: String,
      default: ''
    }
  },

  mounted() {
    console.log(`[Qrpay] mounted props`, this.accountId, this.shopName, this.shopId);
    this.fetchMerchantInfo();
    this.fetchQrs();
  },

  methods: {
    fetchQrs(){
      axios.get(`${process.env.VUE_APP_APIHOST}/gaa/shops/${this.accountId}/qrs`)
      .then(response => {
        console.log(`[Qrpay] fetchQrs response.data`, response.data);
        this.qrsList = response.data;
      })
      .catch(err => {
        console.error(`[Qrpay] fetchQrs error`, err);
      });
    },
    showEditQrsDialog(printer){
      console.log(`[Qrpay] editQrs`, printer.name);
      this.dialog.qrs.show = true;
      this.dialog.qrs.mode ='update'
      this.dialog.qrs.title = `編輯 QR code 出單設定`;
      this.$nextTick(() => {
        this.$set(this.dialog.qrs, 'model', {
        name:printer.name,
        sn:printer.sn,
        server:printer.server,
        templateId:printer.order_template_id,
        platform: "kiosk"
      });
        if (this.$refs['qrsForm']) this.$refs['qrsForm'].resetFields();
      });
    },
    showAddQrsDialog(){
      console.log(`[Qrpay] addQrs`);
      this.dialog.qrs.show = true;
      this.dialog.qrs.mode ='create'
      this.dialog.qrs.title = `新增 QR code 出單設定`;
      this.$nextTick(() => {
        this.$set(this.dialog.qrs, 'model', {
          name: "",
          sn: "",
          server: "",
          templateId: "",
          platform: "kiosk"
        });
        if (this.$refs['qrsForm']) this.$refs['qrsForm'].resetFields();
      });
    },
    deleteQrs(printer){
      console.log(`[Qrpay] deleteQrs`, printer);
      axios.delete(`${process.env.VUE_APP_APIHOST}/gaa/shops/${this.accountId}/qrs/${printer.sn}`).then(response => {
        console.log(`[Qrpay] deleteQrs response.data`, response.data);
        if(response.data.result === 'success'){
          this.$notify.success({
            title: `QR code 出單設定 ${printer.name}（${this.shopId}） 已刪除`
          });
          this.fetchQrs()
        }else{
          this.$notify.error({
            title: `無法刪除QR code 出單設定`,
            message: `${printer.name}（${this.shopId}）`
          });
          console.log('delQrs error', response.data && response.data.message)
        }
      })
      .catch(err => {
        console.error(`[Qrpay] deleteQrs error`, err);
        this.$notify.error({
            title: `無法刪除QR code 出單設定`,
            message: `${printer.name}（${this.shopId}）`
          });
      });
    },
    addQrs(){
      console.log(`[Qrpay] addQrs`);
      this.$refs['qrsForm'].validate((valid) => {
        if (valid) {
          const postData = {
            ...this.dialog.qrs.model,
            shopId: this.shopId,
            shopName: this.shopName,
            printerType: "PT4G",
          }
          axios.post(`${process.env.VUE_APP_APIHOST}/gaa/shops/${this.accountId}/qrs`,postData)
          .then(response => {
            console.log(`[Qrpay] addQrs response.data`, response.data);
            if(response.data.success){
              this.$notify.success({
                title: `QR code 出單設定 ${this.dialog.qrs.model.name}（${this.shopId}） 已建立`
              });
              this.hideEditQrsDialog()
              this.fetchQrs()
            }else{
              this.$notify.error({
                title: `無法建立QR code 出單設定`,
                message: `${this.dialog.qrs.model.name}（${this.shopId}）`
              });
              console.log('add qrs', response.data && response.data.message)
            }
          })
          .catch(err => {
            console.error(`[Qrpay] addQrs error`, err);
            this.$notify.error({
                title: `無法建立QR code 出單設定`,
                message: `${this.dialog.qrs.model.name}（${this.shopId}）`
              });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editQrs(){
      console.log(`[Qrpay] editQrs`);
      this.$refs['qrsForm'].validate((valid) => {
          if (valid) {   
            const postData = {
              name: this.dialog.qrs.model.name,
              templateId: this.dialog.qrs.model.templateId,
            }
            axios.put(`${process.env.VUE_APP_APIHOST}/gaa/shops/${this.accountId}/qrs/${this.dialog.qrs.model.sn}`, postData)
            .then(response => {
              console.log(`[Qrpay] editQrs response.data`, response.data);
              if(response.data.result === 'success'){
                  this.$notify.success({
                    title: `QR code 出單設定 ${this.dialog.qrs.model.name}（${this.shopId}） 已更新`
                  });
                  this.hideEditQrsDialog()
                  this.fetchQrs()
                }else{
                  this.$notify.error({
                    title: `無法更新QR code 出單設定`,
                    message:  `${this.dialog.qrs.model.name}（${this.shopId}）`
                  });
                  console.log('edit qrs', response.data && response.data.message)
                }
              })
              .catch(err => {
                console.error(`[Qrpay] editQrs error`, err);
                this.$notify.error({
                    title: `無法更新QR code 出單設定`,
                    message:  `${this.dialog.qrs.model.name}（${this.shopId}）`
                  });
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    hideEditQrsDialog(){
      this.dialog.qrs.show = false;
      this.$refs['qrsForm'].resetFields();
    },

    fetchMerchantInfo() {
      axios.get(`${process.env.VUE_APP_APIHOST}/gaa/qrpm/merchants/${this.shopId}`)
      .then(response => {
        console.log(`[Qrpay] fetchMerchantInfo response.data`, response.data);
        this.merchant = response.data;

        //TODO: Load payment configs then.
        this.fetchPaymentConfigs();
      })
      .catch(err => {
        console.error(`[Qrpay] fetchMerchantInfo error`, err);
        //TODO: Prompt for creating a QRPay merchant.
        this.showCreateMerchantPrompt();
      });
    },

    fetchPaymentConfigs() {
      axios.get(`${process.env.VUE_APP_APIHOST}/gaa/qrpm/merchants/${this.shopId}/payment-configs`)
      .then(response => {
        console.log(`[Qrpay] fetchPaymentConfigs response.data`, response.data);
        let configs = response.data;
        configs.forEach(c => {
          let service = c['service'], type = c['type'];
          this.paymentConfigs[ service ][ type ] = {
            enabled: c['is_enabled'],
            data: c
          };
        });
      })
      .catch(err => {

      });
    },

    showCreateMerchantPrompt() {
      this.$swal({
        title: '此商店尚未開通QRPay商家',
        text: '您必須開通QRPay商家，才能使用線上支付服務。',
        showCancelButton: true,
        confirmButtonText: '新增QRPay商家',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonText: '取消',
        cancelButtonClass: 'btn btn-default btn-fill'
      })
      .then(result => {
        if (!result.isConfirmed) return;
        // Being creating a new merchant.
        this.dialog.createMerchant.model = {
          name: this.shopName, email: '', phone: '', address: ''
        };
        this.dialog.createMerchant.show = true;
      });
    },

    showConfigPaymentServiceConfig(service, type) {console.log('test');
      if (!this.merchant) {
        this.showCreateMerchantPrompt();
        return;
      }

      if (service == 'tappay') {

        if (this.isTappayConfigured) {
          this.$swal({
            title: 'TapPay已設定',
            text: 'TapPay內容相關請透過QRPay後台設定。',
          });
          return;
        }
        else {
          this.dialog.configPaymentService.model = {
            contactName: '', contactPhone: '', contactAddress: '',
            tappayMerchantId: '',
            types: 'direct',
            useTds: false
          };
          this.dialog.configPaymentService.title = `新增TapPay服務`;
          this.dialog.configPaymentService.mode = 'create';
        }

      }
      else if (service == 'linepay') {

        if (this.paymentConfigs['linepay']['linepay'].data) {
          this.dialog.configPaymentService.model = {
            name: this.paymentConfigs['linepay']['linepay'].data['name'],
            channelId: this.paymentConfigs['linepay']['linepay'].data['channelId'],
            channelSecret: this.paymentConfigs['linepay']['linepay'].data['channelSecret']
          };
          this.dialog.configPaymentService.paymentServiceId = this.paymentConfigs['linepay']['linepay'].data['payment_service_id'];
          this.dialog.configPaymentService.title = `更新LINE Pay服務`;
          this.dialog.configPaymentService.mode = 'update';
        }
        else {
          this.dialog.configPaymentService.model = { channelId: '', channelSecret: '' };
          this.dialog.configPaymentService.title = `新增LINE Pay服務`;
          this.dialog.configPaymentService.mode = 'create';
        }

      }
      else if (service == 'easywallet') {
        
        if (this.paymentConfigs['easywallet']['easywallet'].data) {
          this.dialog.configPaymentService.model = {
            name: this.paymentConfigs['easywallet']['easywallet'].data['name'],
            sellerMemberUid: this.paymentConfigs['easywallet']['easywallet'].data['sellerMemberUid'],
            securityCode: this.paymentConfigs['easywallet']['easywallet'].data['securityCode'],
            contractNo: this.paymentConfigs['easywallet']['easywallet'].data['contractNo'],
            executorId: this.paymentConfigs['easywallet']['easywallet'].data['executorId']
          };
          this.dialog.configPaymentService.paymentServiceId = this.paymentConfigs['easywallet']['easywallet'].data['payment_service_id'];
          this.dialog.configPaymentService.title = `更新悠遊付服務`;
          this.dialog.configPaymentService.mode = 'update';
        }
        else {
          this.dialog.configPaymentService.model = {
            sellerMemberUid: '', securityCode: '', contractNo: '', executorId: ''
          };
          this.dialog.configPaymentService.title = `新增悠遊付服務`;
          this.dialog.configPaymentService.mode = 'create';
        }

      }
      else {
        //TODO:
      }

      this.dialog.configPaymentService.service = service;
      this.dialog.configPaymentService.type = type;
      this.dialog.configPaymentService.show = true;
    },

    createMerchant() {
      let reqBody = this.dialog.createMerchant.model;
      reqBody['merchantId'] = this.shopId;
      axios.post(
        `${process.env.VUE_APP_APIHOST}/gaa/qrpm/merchants`,
        reqBody
      )
      .then(response => {
        this.fetchPaymentConfigs();
        this.$notify.success({
          title: `QRPay商家 ${reqBody['name']}（${this.shopId}） 已建立`
        });
      })
      .catch(err => {
        this.$notify.error({
          title: `無法建立商家：${reqBody['name']}（${this.shopId}）`,
          message: err.data.message
        });
      })
      .finally(() => {
        this.fetchMerchantInfo();
        this.dialog.createMerchant.model = { };
        this.dialog.createMerchant.show = false;
      });
    },
    updateMerchant() {

    },

    createPaymentService() {
      let data = this.dialog.configPaymentService.model;
      data['types'] = data['types']? data['types'].split(','): undefined;
      data['service'] = this.dialog.configPaymentService.service;
      data['merchantId'] = this.shopId;
      console.log(`[Qrpay] createPaymentService request body`, data);
      axios.post(
        `${process.env.VUE_APP_APIHOST}/gaa/qrpm/merchants/${this.shopId}/payment-services`,
        data
      )
      .then(response => {
        this.$notify.success({
          title: `支付服務 ${data['name']} 已新增`
        });
      })
      .catch(err => {
        this.$notify.error({
          title: `無法新增支付服務：${data['name']}`,
          message: err.data.message
        });
      })
      .finally(() => {
        this.fetchPaymentConfigs();//Refresh all payment configs just in case.
        this.dialog.configPaymentService.mode = 'create';
        this.dialog.configPaymentService.model = { };
        this.dialog.configPaymentService.show = false;
      });
    },
    updatePaymentService() {
      let paymentServiceId = this.dialog.configPaymentService.paymentServiceId;
      let data = this.dialog.configPaymentService.model;
      data['service'] = this.dialog.configPaymentService.service;
      console.log(`[Qrpay] updatePaymentService psID: ${paymentServiceId}, request body`, data);
      axios.put(
        `${process.env.VUE_APP_APIHOST}/gaa/qrpm/merchants/${this.shopId}/payment-services/${paymentServiceId}`,
        data
      )
      .then(response => {
        this.$notify.success({
          title: `支付服務 ${data['name']} 已更新`
        });
      })
      .catch(err => {
        this.$notify.error({
          title: `無法修改支付服務：${data['name']}`,
          message: err.data.message
        });
      })
      .finally(() => {
        // this.fetchPaymentConfigs();//Refresh all payment configs just in case.
        this.dialog.configPaymentService.mode = 'create';
        this.dialog.configPaymentService.model = { };
        this.dialog.configPaymentService.show = false;
      });
    },

    togglePaymentConfig(service, type, enable = true) {
      axios.put(
        `${process.env.VUE_APP_APIHOST}/gaa/qrpm/merchants/${this.shopId}/payment-configs`,
        { service, type, enable }
      )
      .then(response => {
        this.$notify.success({
          title: '支付服務已' + (enable? '開啟': '關閉')
        });
      })
      .catch(err => {
        this.paymentConfigs[ service ][ type ].enabled = !enable;
        this.$notify.error({
          title: (enable? '開啟': '關閉') + '支付服務時遭遇錯誤',
          message: err.data.message
        });
      });
    },

    onToggled(serviceType) {
      // console.log(`[Qrpay][DEBUG] onToggled: val ${val}, serviceType ${serviceType}`);
      return evt => {
        console.log(`[Qrpay][DEBUG] onToggled: serviceType ${serviceType}, evt`, evt);
        let checked = evt.target.checked;//Or observe the binded v-model?
        let [ service, type ] = serviceType.split('.');
        if (!checked) {
          this.togglePaymentConfig(service, type, false);
        }
        else {
          // Examine if the payment config is available.
          if (!this.paymentConfigs[ service ][ type ].data) {
            this.$notify.error({
              title: `此支付服務尚未設定，無法開啟。請確認先設定過後再行操作。`,
            });
            setTimeout(() => {
              this.paymentConfigs[ service ][ type ].enabled = false;
            });
          }
          else
            this.togglePaymentConfig(service, type, true);
        }
      };
    }
  },

  data() {
    return {
      merchant: null,
      qrsList: [],
      qrsRule:{
        name: [
              { required: true, message: '這是必填欄位', trigger: 'blur' }
            ],
        sn: [
          { required: true, message: '這是必填欄位', trigger: 'blur' }
        ],
        server: [
          { required: true, message: '這是必填欄位', trigger: 'blur' }
        ],
        templateId: [
          { required: true, message: '這是必填欄位', trigger: 'blur' }
        ],
      },
      serverOptions: [
        {
          value: "iiot",
          label: "IIOT"
        },
        {
          value: "qc",
          label: "QC"
        },
        {
          value: "qc_v2",
          label: "QC_V2"
        }
      ],
      platformOptions:[
        {
          value: "kiosk",
          label: "自助結帳機"
        },
      ],
      paymentConfigs: {

        tappay: {
          apple: {
            enabled: false
          },
          google: {
            enabled: false
          },
          jko: {
            enabled: false
          },
          direct: {
            enabled: false
          }
        },

        linepay: {
          linepay: {
            enabled: false
          }
        },

        easywallet: {
          easywallet: {
            enabled: false
          }
        }

      },

      dialog: {
        qrs: {
          show: false,
          title: '',
          mode: 'create',
          model: { 
            name:"",
            sn:"",
            server:"",
            templateId:"",
            platform:"kiosk"
          }
        },
        createMerchant: {
          show: false,
          model: { }
        },
        configPaymentService: {
          show: false,
          title: '',
          mode: 'create',
          service: null,
          type: null,
          paymentServiceId: null,
          model: { }
        }
      }
    };
  },

  computed: {
    isTappayConfigured() {
      return this.paymentConfigs['tappay']['direct'].data !== undefined
        || this.paymentConfigs['tappay']['jko'].data !== undefined
        || this.paymentConfigs['tappay']['apple'].data !== undefined
        || this.paymentConfigs['tappay']['google'].data !== undefined;
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
<style scoped>
.btn-add-ps {
  background-color: #F96332;
  border-color: white;
  margin-top: 5px
}
.btn-add-ps:hover {
  background-color: #ff8d67;
  border-color: white;
  margin-top: 5px
}
</style>
